import { RootState } from "src/shared/types/src";

export const getBasicDetailsSel = (state: RootState) => state?.profile?.basicDetails;
export const getBasicDetailsLoading = (state: RootState) => state?.profile?.basicDetailsLoading;

export const getParentDetailsSel = (state: RootState) => state?.profile?.parentDetails;
export const getParentDetailsLoading = (state: RootState) => state?.profile?.parentsDetailsLoading;